import { Organization, Language, UserStyle, User } from '../models';
import { HasId } from '../interfaces';

export class UserInfo implements HasId {
    public id: number;
    public firstName: string;
    public lastName: string;
    public email: string;
    public userRole: string;
    public organization: Organization;
    public language: Language;
    public manager: User;
    public title: string;
    public userPermissions: string[];
    public userStyles: UserStyle[];
    public isDeactivated: boolean;
    // public isCandidate: boolean;
    public isDeleted: boolean;
    public resultsArePrivate: boolean;
    public isBeingImpersonated: boolean;
    public userReportTypes: UserReportTypeInfo[];

    // this will be a base 64 string for the users avatar
    public avatar: string;
    public teams: any[];
}

export class UserReportTypeInfo {
    surveyReportTypeID: number;
    surveyID: number;
}


// WEBPACK FOOTER //
// ./src/models/UserInfo.tsx